import React, { useEffect, useMemo } from 'react';
import { AuthContext, ExternalAuthContext } from 'contexts';
import { getOrgLogoSrcFromAuth, isAssumeOrgType } from 'utils';
import { Icon } from 'components/Icon';
import { Link, useLocation, useHistory } from 'react-router-dom';
import { StyledOrgLogoWrapper, StyledLogoButton } from './StyledComponents';

type LogoSectionProps = {
  imageOveride?: string;
  logoType?: 'global' | 'branch';
  collapsed?: boolean;
  openFilePicker?: (editUrl?: string, type?: string) => void;
};

const LogoSectionWrapper: React.FC<LogoSectionProps> = ({
  imageOveride,
  logoType,
  collapsed = true,
  openFilePicker,
}) => {
  const { auth, hasFeature } = React.useContext(AuthContext);
  const { auth: extAuth } = React.useContext(ExternalAuthContext);
  const { search } = useLocation();
  const history = useHistory();
  const imageSrc = useMemo(() => {
    if (!auth && !extAuth) return '';

    if (imageOveride) return imageOveride;

    if (extAuth) return extAuth.orgLogo;

    return getOrgLogoSrcFromAuth(auth);
  }, [auth, extAuth, imageOveride]);

  const showAddLogoBtn = () => (
      hasFeature &&
      hasFeature('MY_BROKERAGE') &&
      (isAssumeOrgType(auth.org.type)
        ? auth.isAssumedNotBB &&
          auth.roles[auth.role] >= auth.roles.BRANCH_ADMIN
        : auth.roles[auth.role] >= auth.roles.BRANCH_ADMIN ||
          auth.isBrokerOfRecord)
    );

  useEffect(() => {
    const query = new URLSearchParams(search);
    const action = query.get('action');
    const queryLogoType = query.get('logoType');
    if (action && action === 'upload-logo') {
      if (openFilePicker) {
        openFilePicker('', queryLogoType || logoType);
        query.delete('action');
        history.replace({
          search: query.toString(),
        });
      }
    }
  }, [search]);

  const EditableLogoSection = () =>
    showAddLogoBtn() ? (
      <StyledOrgLogoWrapper collapsed={collapsed}>
        <div className="org-logo-circle">
          <Link to="/org/settings?action=upload-logo&logoType=global">
            <StyledLogoButton
              className="add-logo-btn"
              icon={<Icon type="antdPlusCircleOutlined" width={18} />}
            >
              <span className="btn-text">Add logo</span>
            </StyledLogoButton>
          </Link>
        </div>
      </StyledOrgLogoWrapper>
    ) : (
      <></>
    );

  const LogoSection = () =>
    imageSrc ? (
      <StyledOrgLogoWrapper collapsed={collapsed}>
        <div className="org-logo-circle">
          <img src={imageSrc} />
        </div>
      </StyledOrgLogoWrapper>
    ) : (
      <></>
    );

  return <>{imageSrc ? <LogoSection /> : <EditableLogoSection />}</>;
};

export default LogoSectionWrapper;
